export const FINANCIAL_TEXT = {
  page: {
    title: 'Financiero',
    subtitle: 'Control de cuentas, traspasos y movimientos de tesorería.',
    tabsAriaLabel: 'Secciones financieras',
  },
  actions: {
    header: {
      newAccount: 'Cuenta',
      transfer: 'Traspaso',
      syncFinancial: 'Sincronizar',
    },
    table: {
      empty: 'Sin movimientos recientes para los filtros aplicados.',
    },
  },
  kpis: {
    availableBalance: 'Saldo disponible',
    entries: 'Entradas',
    exits: 'Salidas',
    netFlow: 'Flujo neto',
  },
  tabs: {
    summary: 'Resumen',
    bankAccounts: 'Cuentas bancarias',
    transfers: 'Traspasos',
    conciliation: 'Conciliación',
    history: 'Histórico',
  },
  detailAccount: {
    page: {
      title: 'Financiero',
      backLabel: 'Volver a financiero',
      tabsAriaLabel: 'Pestañas de cuenta financiera',
      breadcrumbAriaLabel: 'Navegación de cuenta financiera',
      defaultAccountTitle: 'Cuenta financiera',
    },
    tabs: {
      summary: 'Resumen',
      movements: 'Movimientos',
      history: 'Historial',
    },
    actions: {
      edit: 'Editar',
      sync: 'Sincronizar',
      export: 'Exportar',
      cancel: 'Cancelar',
    },
    status: {
      active: 'Activa',
      inactive: 'Inactiva',
    },
    movements: {
      searchPlaceholder: 'Buscar por concepto, referencia o tipo',
      empty: 'No hay movimientos para los filtros seleccionados.',
      exportFileName: 'movimientos_cuenta_financiera.csv',
      dateRangePresets: [
        { key: 'this_month', label: 'Este mes' },
        { key: 'last_month', label: 'Mes anterior' },
        { key: 'this_year', label: 'Año actual' },
        { key: 'last_year', label: 'Año anterior' },
      ],
      filters: {
        toggleButton: 'Mostrar más filtros',
        noOptions: 'Sin opciones',
        period: {
          none: 'Sin selección',
        },
        movementType: {
          label: 'Tipo de movimiento',
          options: {
            all: 'Todos',
            income: 'Depósitos',
            expense: 'Retiros',
          },
        },
        type: {
          label: 'Tipo',
        },
      },
      table: {
        date: 'Fecha',
        concept: 'Concepto',
        movementType: 'Tipo de movimiento',
        deposit: 'Depósito',
        withdrawal: 'Retiro',
        balance: 'Saldo',
        total: 'Total',
        monthFallback: 'Período sin fecha',
      },
      categories: {
        all: 'Todos',
        income: 'Ingreso',
        expense: 'Egreso',
        transfer: 'Traspaso',
        init: 'Saldo inicial',
        otherincome: 'Otro ingreso',
        otherexpense: 'Otro gasto',
      },
    },
    summary: {
      emptyValue: '',
      dashboard: {
        balanceTitle: 'Saldo actual',
        entriesMonth: 'Entradas este mes',
        exitsMonth: 'Salidas este mes',
        lastMovement: 'Último movimiento',
        evolutionTitle: 'Evolución del saldo',
        ranges: {
          d30: '30D',
          m3: '3M',
          m6: '6M',
          y1: '1A',
        },
        recentTitle: 'Movimientos recientes',
        viewMovements: 'Ver movimientos',
        emptyRecent: 'Sin movimientos recientes.',
      },
      general: {
        title: 'General',
        editAction: 'Editar general',
        fields: {
          name: 'Nombre de cuenta',
          type: 'Tipo de cuenta',
          currency: 'Moneda',
          balance: 'Saldo actual',
          default: 'Predeterminada',
          deposits: 'Mostrar datos de depósito en facturas',
          startDate: 'Fecha inicial',
          startBalance: 'Saldo inicial',
          creditLimit: 'Límite de crédito',
          breakDay: 'Día de corte',
          paymentDay: 'Día de pago',
          status: 'Estado',
        },
      },
      bank: {
        title: 'Bancario',
        editAction: 'Editar bancario',
        fields: {
          bank: 'Banco',
          bankRfc: 'RFC del banco',
          branch: 'Sucursal',
          holder: 'Titular',
          accountNumber: 'Número de cuenta',
          cardNumber: 'Número de tarjeta',
          clabe: 'CLABE',
          swift: 'SWIFT',
          aba: 'ABA',
        },
      },
    },
    history: {
      title: 'Historial de actividad',
      subtitle: 'Registro cronológico de cambios de la cuenta.',
      loading: 'Cargando historial...',
      empty: 'Sin movimientos registrados en el historial.',
      table: {
        headers: {
          index: '#',
          date: 'Fecha',
          module: 'Módulo',
          event: 'Evento',
          description: 'Descripción',
          user: 'Usuario',
        },
      },
      fallback: {
        date: '-',
        module: 'General',
        event: 'Cambio',
        description: 'Actividad registrada',
        actor: 'Sistema',
      },
    },
    confirm: {
      sync: {
        title: 'Sincronizar saldo de la cuenta',
        subtitle: 'Esta acción recalcula saldos con base en los movimientos de esta cuenta financiera.',
        message: (name) => `La sincronización recorrerá las transacciones financieras de la cuenta ${name} y recalculará los saldos de cada movimiento y el saldo final de la cuenta.\n\nEste proceso puede tardar unos minutos según el volumen de información.\n\n¿Deseas iniciar la sincronización ahora?`,
        confirm: 'Iniciar sincronización',
      },
      enable: {
        title: 'Habilitar cuenta',
        subtitle: 'Esta acción habilitará nuevamente la cuenta seleccionada.',
        confirm: 'Habilitar',
        message: (name) => `La cuenta ${name} quedará activa nuevamente. ¿Deseas continuar?`,
      },
      disable: {
        title: 'Deshabilitar cuenta',
        subtitle: 'Esta acción deshabilitará la cuenta seleccionada.',
        confirm: 'Deshabilitar',
        message: (name) => `La cuenta ${name} quedará inactiva. ¿Deseas continuar?`,
      },
      delete: {
        title: 'Eliminar cuenta',
        subtitle: 'Esta acción eliminará la cuenta seleccionada.',
        confirm: 'Eliminar',
        message: (name) => `La cuenta ${name} será eliminada. ¿Deseas continuar?`,
      },
    },
    messages: {
      pendingTab: 'Esta pestaña se implementará después.',
      loadError: 'No fue posible cargar la información de la cuenta.',
      syncStarting: 'Iniciando sincronización de saldo de la cuenta financiera. Este proceso puede tardar unos minutos.',
      syncSuccess: 'Saldo de cuenta sincronizado correctamente.',
      syncError: 'No fue posible sincronizar el saldo de la cuenta.',
      syncCooldown: (minutes) => `Ya existe una sincronización reciente para esta cuenta. Intenta nuevamente en ${minutes} minuto${minutes === 1 ? '' : 's'}.`,
      updateSuccess: 'Cuenta actualizada correctamente.',
      updateError: 'No fue posible actualizar la cuenta.',
      enableSuccess: 'Cuenta habilitada correctamente.',
      enableError: 'No fue posible habilitar la cuenta.',
      disableSuccess: 'Cuenta deshabilitada correctamente.',
      disableError: 'No fue posible deshabilitar la cuenta.',
      deleteSuccess: 'Cuenta eliminada correctamente.',
      deleteError: 'No fue posible eliminar la cuenta.',
      actionError: 'No fue posible completar la acción.',
    },
  },
  exports: {
    modal: {
      title: 'Exportar movimientos financieros',
      subtitle: 'Selecciona columnas para exportar movimientos y guarda tu formato para reutilizarlo.',
      format: {
        title: 'Formato de exportación',
        selectorLabel: 'Formato',
        selectorPlaceholder: 'Selecciona una opción',
        newOption: 'Nuevo formato',
        save: 'Guardar formato',
        saveAs: 'Guardar como',
        delete: 'Eliminar formato',
        saving: 'Guardando...',
        deleting: 'Eliminando...',
        nameLabel: 'Nombre del formato',
        namePlaceholder: 'Ej. Movimientos operativos',
        nameRequired: 'Debes capturar el nombre del formato.',
        duplicateConfirm: 'Ya existe un formato con ese nombre. ¿Deseas reemplazarlo?',
        deleteConfirm: '¿Deseas eliminar este formato de exportación?',
        copySuffix: 'copia',
      },
      columns: {
        title: 'Columnas a exportar',
        subtitle: 'Activa las columnas para el archivo. El orden de selección se respeta.',
        selectAll: 'Todas',
        clearSelection: 'Limpiar',
        restoreDefault: 'Restaurar',
        selectedCount: (count) => `${count} columna${count === 1 ? '' : 's'} seleccionada${count === 1 ? '' : 's'}`,
        orderTitle: 'Orden de columnas',
        orderSubtitle: 'Ajusta el orden con los controles de subir y bajar.',
        orderEmpty: 'No hay columnas seleccionadas.',
      },
      groups: {
        movement: 'Movimiento',
        amounts: 'Montos',
      },
      exportOptions: {
        title: 'Opciones de exportación',
        outputLabel: 'Formato de salida',
        outputOptions: {
          excel: 'Excel',
          pdf: 'PDF',
        },
        includeSummaryLabel: 'Incluir resumen de la cuenta',
        includeLogoLabel: 'Mostrar logo de la cuenta (PDF)',
      },
      footer: {
        cancel: 'Cancelar',
        saveAndExport: 'Guardar y exportar',
        exportOnly: 'Exportar',
        exporting: 'Exportando...',
      },
      toast: {
        loadError: 'No fue posible cargar la configuración de exportación.',
        noColumns: 'Debes seleccionar al menos una columna para exportar.',
        formatSaved: 'Formato de exportación guardado correctamente.',
        formatUpdated: 'Formato de exportación actualizado correctamente.',
        formatDeleted: 'Formato de exportación eliminado correctamente.',
        formatError: 'No fue posible guardar el formato de exportación.',
        formatDeleteError: 'No fue posible eliminar el formato de exportación.',
        exportSuccess: 'Exportación de movimientos generada correctamente.',
        exportError: 'No fue posible exportar los movimientos.',
      },
    },
    settings: {
      deleteModal: {
        title: 'Eliminar formato de exportación',
        subtitle: 'Confirma para continuar con esta operación.',
        message: (formatName) => `Formato: ${formatName}. ¿Deseas eliminar este formato de exportación? Esta acción no se puede deshacer.`,
        confirm: 'Eliminar',
      },
      table: {
        actions: {
          delete: 'Eliminar',
        },
      },
    },
  },
  summary: {
    cardsTitle: 'Cuentas de tesorería',
    distributionTitle: 'Distribución por cuenta',
    distributionTotal: '100% total',
    tableTitle: 'Movimientos recientes',
    filters: {
      all: 'Todas las transacciones',
      incomes: 'Ingresos',
      expenses: 'Egresos',
      transfers: 'Transferencias internas',
      searchPlaceholder: 'Buscar por concepto o referencia',
    },
    addCard: {
      title: 'Nueva cuenta',
      subtitle: 'Crea una cuenta para registrar movimientos y saldos de tesorería.',
    },
    labels: {
      available: 'Saldo disponible',
      movements: 'Movimientos',
      account: 'Cuenta',
      inactiveNoBalance: 'Sin saldo disponible por inactividad',
    },
    status: {
      active: 'Activa',
      inactive: 'Inactiva',
    },
    table: {
      date: 'Fecha',
      account: 'Cuenta',
      concept: 'Concepto',
      category: 'Categoría',
      amount: 'Monto',
    },
  },
  bankAccounts: {
    title: 'Cuentas bancarias',
    subtitle: 'Administra y consulta todas las cuentas de tesorería.',
    searchPlaceholder: 'Buscar cuenta, banco o referencia',
    tabs: {
      active: 'Activas',
      inactive: 'Inactivas',
    },
    empty: 'No hay cuentas para los filtros seleccionados.',
    card: {
      owner: 'Responsable',
      branch: 'Sucursal',
      movements: 'Movimientos',
      lastSync: 'Última sincronización',
    },
  },
  historyTab: {
    title: 'Histórico financiero',
    subtitle: 'Registro consolidado de cuentas, traspasos y conciliación.',
    loading: 'Cargando histórico...',
    empty: 'Sin actividad registrada para las cuentas financieras.',
    table: {
      headers: {
        index: '#',
        date: 'Fecha',
        module: 'Módulo',
        event: 'Evento',
        description: 'Descripción',
        user: 'Usuario',
      },
    },
    fallback: {
      date: '-',
      module: 'General',
      event: 'Cambio',
      description: 'Actividad registrada',
      actor: 'Sistema',
    },
  },
  conciliationTab: {
    tabsAriaLabel: 'Pestañas de conciliación financiera',
    tabs: {
      unassigned: 'Sin asignar',
      assigned: 'Asignados',
    },
    loading: 'Cargando movimientos de conciliación...',
    empty: 'No hay movimientos para los filtros seleccionados.',
    toolbar: {
      searchPlaceholder: 'Buscar por concepto o referencia',
      searchButtonTitle: 'Buscar',
      filtersButtonTitle: 'Mostrar más filtros',
      emptyOption: 'Sin opciones',
      allOptionLabels: {
        customer: 'Todos los clientes',
        account: 'Todas las cuentas',
        supplier: 'Todos los proveedores',
        collaborator: 'Todos los colaboradores',
      },
      selectionAllLabels: {
        customer: 'Todos los clientes',
        account: 'Todas las cuentas',
        supplier: 'Todos los proveedores',
        collaborator: 'Todos los colaboradores',
      },
      dateRangePresets: [
        { key: 'this_month', label: 'Este mes' },
        { key: 'last_month', label: 'Mes anterior' },
        { key: 'this_year', label: 'Año actual' },
        { key: 'last_year', label: 'Año anterior' },
      ],
      filters: {
        customer: {
          label: 'Cliente',
          placeholder: 'Selecciona cliente',
          searchable: true,
        },
        account: {
          label: 'Cuenta',
          placeholder: 'Selecciona cuenta',
          searchable: true,
        },
        supplier: {
          label: 'Proveedor',
          placeholder: 'Selecciona proveedor',
          searchable: true,
        },
        collaborator: {
          label: 'Colaborador',
          placeholder: 'Selecciona colaborador',
          searchable: true,
        },
        movementType: {
          label: 'Tipo de movimiento',
          placeholder: 'Selecciona tipo de movimiento',
          options: {
            all: 'Todos',
            income: 'Depósitos',
            expense: 'Retiros',
          },
        },
        type: {
          label: 'Tipo',
          placeholder: 'Selecciona tipo',
          options: {
            all: 'Todos',
            income: 'Ingreso',
            expense: 'Egreso',
            transfer: 'Traspaso',
            init: 'Saldo inicial',
            otherincome: 'Otro ingreso',
            otherexpense: 'Otro gasto',
          },
        },
      },
    },
    table: {
      unassigned: {
        date: 'Fecha',
        type: 'Tipo',
        concept: 'Concepto',
        amount: 'Monto',
      },
      assigned: {
        date: 'Fecha',
        account: 'Cuenta',
        movement: 'Movimiento',
        concept: 'Concepto',
        deposit: 'Depósito',
        withdrawal: 'Retiro',
        balance: 'Saldo',
      },
      actions: {
        review: 'Revisar',
      },
    },
    messages: {
      loadError: 'No fue posible cargar la conciliación financiera.',
      saveSuccess: 'Movimiento de conciliación actualizado correctamente.',
      saveError: 'No fue posible actualizar el movimiento de conciliación.',
      deleteSuccess: 'Movimiento de conciliación eliminado correctamente.',
      deleteError: 'No fue posible eliminar el movimiento de conciliación.',
    },
    modal: {
      title: 'Editar movimiento',
      subtitle: 'Revisa y actualiza la asignación de la conciliación.',
      closeAriaLabel: 'Cerrar',
      fields: {
        detail: 'Detalle:',
        date: 'Fecha inicial',
        amount: 'Monto',
        account: 'Cuenta',
      },
      placeholders: {
        account: 'Sin cuenta asignada',
      },
      actions: {
        cancel: 'Cancelar',
        update: 'Actualizar',
        delete: 'Eliminar',
      },
      confirmDelete: {
        title: 'Eliminar movimiento',
        subtitle: 'Confirma para continuar con esta operación.',
        message: '¿Deseas eliminar este movimiento perdido de conciliación?',
        confirm: 'Eliminar',
      },
    },
  },
  transfersTab: {
    title: 'Traspasos',
    subtitle: 'Gestiona traspasos internos entre cuentas financieras.',
    common: {
      noOptions: 'Sin opciones',
    },
    actions: {
      cancel: 'Cancelar',
      create: 'Guardar',
      update: 'Actualizar',
    },
    toolbar: {
      searchPlaceholder: 'Buscar por concepto o cuenta',
      searchButton: 'Buscar',
      toggleFilters: 'Mostrar más filtros',
      sourceAccountLabel: 'Cuenta origen',
      destinationAccountLabel: 'Cuenta destino',
      allAccounts: 'Todas',
      noOptions: 'Sin opciones',
      dateRangePresets: [
        { key: 'this_month', label: 'Este mes' },
        { key: 'last_month', label: 'Mes anterior' },
        { key: 'this_year', label: 'Año actual' },
        { key: 'last_year', label: 'Año anterior' },
      ],
    },
    table: {
      loading: 'Cargando traspasos...',
      empty: 'No hay traspasos para los filtros seleccionados.',
      headers: {
        index: '#',
        date: 'Fecha',
        sourceAccount: 'Cuenta origen',
        targetAccount: 'Cuenta destino',
        concept: 'Concepto',
        sourceAmount: 'Monto saliente',
        targetAmount: 'Monto entrante',
      },
      actions: {
        edit: 'Editar traspaso',
        delete: 'Eliminar traspaso',
      },
    },
    modal: {
      closeAriaLabel: 'Cerrar',
      create: {
        title: 'Nuevo traspaso',
        subtitle: 'Registra un traspaso entre cuentas financieras.',
      },
      edit: {
        title: 'Editar traspaso',
        subtitle: 'Actualiza la información del traspaso.',
      },
      fields: {
        date: 'Fecha',
        sourceAccount: 'Cuenta origen',
        targetAccount: 'Cuenta destino',
        amount: 'Monto',
        description: 'Concepto',
      },
      placeholders: {
        unassignedAccount: 'Sin cuenta asignada',
        description: 'Ej. Traspaso operativo semanal',
        amount: 'Ej. 0.00',
      },
    },
    confirmDelete: {
      title: 'Eliminar traspaso',
      subtitle: 'Confirma para continuar con esta operación.',
      message: '¿Deseas eliminar este traspaso financiero?',
      confirm: 'Eliminar',
    },
    toast: {
      loadError: 'No fue posible cargar los traspasos.',
      createSuccess: 'Traspaso registrado correctamente.',
      createError: 'No fue posible registrar el traspaso.',
      updateSuccess: 'Traspaso actualizado correctamente.',
      updateError: 'No fue posible actualizar el traspaso.',
      deleteSuccess: 'Traspaso eliminado correctamente.',
      deleteError: 'No fue posible eliminar el traspaso.',
    },
  },
  modal: {
    createAccount: {
      title: 'Nueva cuenta financiera',
      subtitle: 'Configura datos generales y bancarios de la cuenta.',
      closeAriaLabel: 'Cerrar',
      sectionMenuAriaLabel: 'Secciones de cuenta financiera',
      sections: {
        general: {
          title: 'General',
          description: 'Datos base, saldos y comentarios',
          heading: 'General y saldos',
          subtitle: 'Define identificación, configuración y saldos iniciales de la cuenta.',
        },
        bank: {
          title: 'Bancario',
          description: 'Banco, titular y referencias',
          heading: 'Datos bancarios',
          subtitle: 'Registra información de banco, titular y referencias de operación.',
        },
      },
      fields: {
        name: 'Nombre de cuenta *',
        accountType: 'Tipo de cuenta *',
        accountTypePlaceholder: 'Selecciona tipo',
        currency: 'Moneda *',
        currencyPlaceholder: 'Selecciona moneda',
        configuration: 'Configuración',
        status: 'Estado',
        active: 'Activa',
        inactive: 'Inactiva',
        isDefault: 'Predeterminada',
        isDefaultHelp: 'Usar como cuenta predeterminada',
        showDeposits: 'Depósitos en facturas',
        showDepositsHelp: 'Mostrar datos de depósito en facturas',
        startDate: 'Fecha inicial',
        startDatePlaceholder: 'Selecciona fecha inicial',
        startBalance: 'Saldo inicial',
        amountPlaceholder: 'Ej. 0.00',
        creditLimit: 'Límite de crédito',
        breakDay: 'Día de corte',
        paymentDay: 'Día de pago',
        comments: 'Comentarios',
        commentsPlaceholder: 'Notas internas de la cuenta',
        bank: 'Banco',
        bankPlaceholder: 'Selecciona banco',
        bankRfc: 'RFC del banco',
        bankBranch: 'Sucursal',
        bankAddress: 'Dirección de banco',
        holder: 'Titular',
        accountNumber: 'Número de cuenta',
        cardNumber: 'Número de tarjeta',
        clabe: 'CLABE',
        swift: 'SWIFT',
        aba: 'ABA',
      },
      placeholders: {
        name: 'Ej. BBVA Operativa',
        bankRfc: 'Ej. BBA830831LJ2',
        bankBranch: 'Ej. Matriz',
        bankAddress: 'Ej. Av. Principal 100',
        holder: 'Ej. Empresa SA de CV',
        accountNumber: 'Ej. 1234567890',
        cardNumber: 'Ej. 4111111111111111',
        clabe: 'Ej. 012180001234567890',
        swift: 'Ej. BCMRMXMM',
        aba: 'Ej. 021000021',
      },
      actions: {
        cancel: 'Cancelar',
        save: 'Guardar',
        saving: 'Guardando...',
      },
      messages: {
        noOption: 'Sin opción disponible',
        requiredField: 'Este campo es requerido.',
        invalidRequired: 'Completa los campos obligatorios: nombre y tipo de cuenta.',
        invalidNameFormat: 'El nombre solo permite letras, números, espacios, punto y guion.',
        invalidDayRange: 'Día de corte y día de pago deben estar entre 1 y 31.',
        createSuccess: 'Cuenta registrada correctamente.',
        createError: 'No fue posible registrar la cuenta.',
        today: 'Hoy',
      },
    },
    editAccount: {
      title: 'Editar cuenta financiera',
      subtitle: 'Actualiza la configuración general y bancaria de la cuenta.',
      closeAriaLabel: 'Cerrar',
      actions: {
        save: 'Actualizar',
        enable: 'Habilitar cuenta',
        disable: 'Deshabilitar cuenta',
        delete: 'Eliminar cuenta',
      },
      confirm: {
        enable: {
          title: 'Habilitar cuenta',
          subtitle: 'Esta acción habilitará nuevamente la cuenta seleccionada.',
          confirm: 'Habilitar',
          message: (name) => `La cuenta ${name} quedará activa nuevamente. ¿Deseas continuar?`,
        },
        disable: {
          title: 'Deshabilitar cuenta',
          subtitle: 'Esta acción deshabilitará la cuenta seleccionada.',
          confirm: 'Deshabilitar',
          message: (name) => `La cuenta ${name} quedará inactiva. ¿Deseas continuar?`,
        },
        delete: {
          title: 'Eliminar cuenta',
          subtitle: 'Esta acción eliminará la cuenta seleccionada.',
          confirm: 'Eliminar',
          message: (name) => `La cuenta ${name} será eliminada. ¿Deseas continuar?`,
        },
      },
      messages: {
        loadError: 'No fue posible cargar la información de la cuenta.',
        updateSuccess: 'Cuenta actualizada correctamente.',
        updateError: 'No fue posible actualizar la cuenta.',
        enableSuccess: 'Cuenta habilitada correctamente.',
        enableError: 'No fue posible habilitar la cuenta.',
        disableSuccess: 'Cuenta deshabilitada correctamente.',
        disableError: 'No fue posible deshabilitar la cuenta.',
        deleteSuccess: 'Cuenta eliminada correctamente.',
        deleteError: 'No fue posible eliminar la cuenta.',
        actionError: 'No fue posible completar la acción.',
      },
    },
  },
  confirm: {
    sync: {
      title: 'Sincronizar saldos financieros',
      subtitle: 'Esta acción recalcula saldos con base en los movimientos de tus cuentas financieras.',
      message: `La sincronización recorre las transacciones financieras de la cuenta y recalcula los saldos de cada movimiento y de cada cuenta bancaria.

Este proceso puede tardar unos minutos según el volumen de información.

¿Deseas iniciar la sincronización ahora?`,
      confirm: 'Iniciar sincronización',
    },
  },
  toast: {
    syncStarting: 'Iniciando sincronización de saldos financieros. Este proceso puede tardar unos minutos.',
    syncSuccess: 'Saldos financieros sincronizados correctamente.',
    syncError: 'No fue posible sincronizar los saldos financieros.',
    syncCooldown: (minutes) => `Ya existe una sincronización reciente. Intenta nuevamente en ${minutes} minuto${minutes === 1 ? '' : 's'}.`,
  },
  placeholders: {
    transfers: {
      title: 'Traspasos',
      subtitle: 'Aquí podrás gestionar traspasos internos entre cuentas.',
    },
    conciliation: {
      title: 'Conciliación',
      subtitle: 'Aquí podrás revisar y validar conciliaciones bancarias.',
    },
    history: {
      title: 'Histórico',
      subtitle: 'Aquí podrás consultar el histórico financiero consolidado.',
    },
  },
};
